import Repository from "./Repository";

const resource = "/File";

export default {
  uploadFile({ file }) {
    let formData = new FormData();
    formData.append("file", file);

    return Repository.post(`${resource}/Upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
};
